var DEFAULT_VALUES = /*#__PURE__*/function (DEFAULT_VALUES) {
  DEFAULT_VALUES[DEFAULT_VALUES["MAX"] = 100] = "MAX";
  DEFAULT_VALUES[DEFAULT_VALUES["MIN"] = 1] = "MIN";
  DEFAULT_VALUES[DEFAULT_VALUES["STEP"] = 1] = "STEP";
  DEFAULT_VALUES[DEFAULT_VALUES["VALUE"] = 1] = "VALUE";
  return DEFAULT_VALUES;
}(DEFAULT_VALUES || {});
export default DEFAULT_VALUES;